import {
  postWithFormData,
  get
} from '../configApi'

// Image
export async function uploadImagePublic(type, file) {
  return await postWithFormData(`/uploadfile/image/${type}`, file)
}
export async function uploadImage(type, file) {
  return await postWithFormData(`/uploadfile/public/image/${type}`, file)
}
export async function uploadPrivateImage(type, file) {
  return await postWithFormData(`/uploadfile/image/private/${type}`, file)
}
export async function getImageByID(id_course, id_image) {
  return await get(`/uploadfile/image/private/${id_course}/${id_image}`)
}

// Video byteArk
export async function getPrivateVideo(idvideo) {
  return await get(`/uploadfile/preview/video`, {
    idvideo: idvideo
  })
}

//PDF
export async function getPrivatePdf(idpdf) {
  return await get(`/uploadfile/preview/pdf`, {
    idpdf: idpdf
  })
}

//File
export async function getPrivateFile(idfile) {
  return await get(`/uploadfile/preview/file`, {
    idfile: idfile
  })
}

//File
export async function getPrivateImage(idimage) {
  return await get(`/uploadfile/preview/image`, {
    idimage: idimage
  })
}


//upload video exam
export async function uploadVideoExam(file) {
  return await postWithFormData(`/uploadfile/video`, file)
}